import * as React from "react";
import { useTranslation, Trans } from "react-i18next";
import styled from "styled-components";
import DocsHelper from "util/DocsHelper";
import DocumentationLink from "components/support/DocumentationLink";
import Panel from "components/bootstrap/Panel";
import Icon from "./Icon";
const Header = styled(Panel.Title)`
  display: flex;
  align-items: center;
`;
const HeaderIcon = styled(Icon)`
  margin-right: 5px;
  margin-top: -1px;
`;
const LicenseLink = ({ children = void 0 }) => /* @__PURE__ */ React.createElement("a", { href: "https://www.graylog.org/products/enterprise", rel: "noopener noreferrer", target: "_blank" }, children);
const EnterpriseSetupLink = ({ children = void 0 }) => /* @__PURE__ */ React.createElement(DocumentationLink, { page: DocsHelper.PAGES.ENTERPRISE_SETUP, text: children });
const EnterprisePluginNotFound = ({ featureName, wrapperClassName = "no-bm" }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(Panel, { bsStyle: "info", className: wrapperClassName }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(HeaderIcon, { name: "enterprise" }), t("enterprise_plugin_not_found.title"))), /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "enterprise_plugin_not_found.description",
      values: { featureName },
      components: {
        bold: /* @__PURE__ */ React.createElement("b", null),
        licenseLink: /* @__PURE__ */ React.createElement(LicenseLink, null),
        docsLink: /* @__PURE__ */ React.createElement(EnterpriseSetupLink, null)
      }
    }
  )));
};
export default EnterprisePluginNotFound;
